import React from 'react';
import { TrophyIcon, GlobeIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
export function Offer() {
  return <section className="relative overflow-hidden bg-ink-950 py-12 sm:py-16" aria-labelledby="offer-title" id="offer" data-id="element-222" data-mp="3067za30h9w6y">
      <div className="mx-auto w-full max-w-2xl px-4 sm:px-6" data-id="element-223" data-mp="353znaly04y5v">
        <h2 id="offer-title" className="flex flex-col items-center gap-2 text-center font-display text-[1.75rem] font-extrabold uppercase leading-[1.02] text-white sm:text-4xl" data-id="element-224" data-mp="3a4npm3rol1fe">
          <TrophyIcon className="h-8 w-8 text-gold-500" aria-hidden="true" data-id="element-225" data-mp="3jvs1gum28660" />
          The special launch offer
        </h2>
        <p className="mt-3 text-center text-sm font-bold uppercase tracking-[0.15em] text-gold-400" data-id="element-226" data-mp="3nyy8w5kws3e2">
          Here’s everything you’ll receive today
        </p>

        <div className="mt-7 overflow-hidden rounded-2xl border border-white/10 bg-ink-900" data-id="element-227" data-mp="1qf23a40n0u3">
          <div className="flex items-center justify-between gap-3 border-b border-white/10 px-4 py-4" data-id="element-228" data-mp="1kmjewzjm8t3h">
            <div className="min-w-0" data-id="element-229" data-mp="1fllvkjmvdt0e">
              <p className="font-display text-base font-extrabold uppercase leading-tight text-white sm:text-lg" data-id="element-230" data-mp="1foq7k36ktt1m">
                📘 Premium Technician Kit™
              </p>
              <p className="text-xs font-semibold text-steel-500" data-id="element-231" data-mp="16n9z40zbo101">6 premium volumes</p>
            </div>
            <span className="shrink-0 font-display text-lg font-bold text-steel-300 line-through" data-id="element-232" data-mp="23b6dr0b78m8m">
              $147
            </span>
          </div>
          <div className="flex items-center justify-between gap-3 border-b border-white/10 px-4 py-4" data-id="element-233" data-mp="1uj4ev6gs3e0g">
            <div className="min-w-0" data-id="element-234" data-mp="1plcrmpr2wg2l">
              <p className="font-display text-base font-extrabold uppercase leading-tight text-white sm:text-lg" data-id="element-235" data-mp="1pkb3bjl1xx2x">
                🎁 5 exclusive bonus systems
              </p>
              <p className="text-xs font-semibold text-steel-500" data-id="element-236" data-mp="2i8go26c3vm2r">
                Scripts · Pricing · Warranty · Reviews · 30-day plan
              </p>
            </div>
            <span className="shrink-0 font-display text-lg font-bold text-steel-300 line-through" data-id="element-237" data-mp="3653jokott85h">
              $235
            </span>
          </div>
          <div className="flex items-center justify-between gap-3 bg-white/[0.06] px-4 py-4" data-id="element-238" data-mp="2scx3wzpl536k">
            <p className="font-display text-lg font-extrabold uppercase tracking-wide text-gold-400" data-id="element-239" data-mp="2wcxsveab8wrv">
              Total value
            </p>
            <span className="font-display text-2xl font-extrabold text-gold-400 line-through decoration-red-500 decoration-2" data-id="element-240" data-mp="2ndsx2fq4vhje">
              $382
            </span>
          </div>
        </div>

        <div className="mt-6 space-y-1.5 text-center text-[15px] font-semibold text-steel-300 sm:text-lg" data-id="element-241" data-mp="2dfmudvwi67dh">
          <p data-id="element-242" data-mp="7meqwa3zo07c">But you won’t pay $382.</p>
          <p data-id="element-243" data-mp="7ng34hwqqsqn">You won’t even pay half.</p>
        </div>

        <div className="mt-6 rounded-2xl border-2 border-gold-500 bg-ink-900 p-5 text-center sm:p-7" data-id="element-244" data-mp="bo9q992d03ih">
          <p className="font-display text-sm font-bold uppercase tracking-[0.15em] text-gold-400" data-id="element-245" data-mp="1w62fwcskttfy">
            Today you can get complete access for only…
          </p>
          <p className="mt-2 font-display text-[4.5rem] font-extrabold leading-none text-white sm:text-[6rem]" data-id="element-246" data-mp="1s35ru6k9p54m">
            $27
            <span className="ml-2 align-middle font-display text-2xl font-bold text-gold-500 sm:text-3xl" data-id="element-247" data-mp="2155at4eueja7">
              USD
            </span>
          </p>
          <p className="mt-1 font-display text-xl font-extrabold uppercase tracking-wide text-gold-500" data-id="element-248" data-mp="2fsqfv3va2skr">
            One-time payment
          </p>
          <p className="mt-2 text-sm font-medium text-steel-300" data-id="element-249" data-mp="2ovrfqmtjvnfz">
            No monthly fees · Lifetime access · Instant download
          </p>
          <p className="mt-4 text-sm leading-relaxed text-steel-300" data-id="element-250" data-mp="2jwy28ue9jwft">
            That’s less than the cost of many service calls — for a complete
            professional toolkit you can use across your business.
          </p>

          <div className="mt-6" data-id="element-251" data-mp="rwsjoq39hoc8">
            <CTAButton label="Get the Premium Technician Kit™ for $27" sub="Instant Download · One-Time Payment · Lifetime Access · 7-Day Guarantee" data-id="element-252" data-mp="rxk89gyfylt0" />
          </div>

          <div className="mt-5" data-id="element-253" data-mp="10yid21gpexcn">
            <Countdown data-id="element-254" data-mp="10vdz4cdfsn8s" />
          </div>

          <div className="mt-5" data-id="element-255" data-mp="15x3bpwgb58yz">
            <ScarcityBar label="Limited promotional availability" data-id="element-256" data-mp="15v8o2adnj2r7" />
          </div>

          <p className="mt-4 flex items-center justify-center gap-2 text-xs font-semibold text-steel-500" data-id="element-257" data-mp="89ujlilsx1o0">
            <GlobeIcon className="h-4 w-4 shrink-0 text-gold-500" aria-hidden="true" data-id="element-258" data-mp="d8nztish36rv" />
            Automatic currency conversion — your currency is converted
            automatically based on your location.
          </p>
        </div>
      </div>
    </section>;
}